import { useCallback } from 'react'
import {
  ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	dpcApi,
	sisetuApiBy,
} from 'interface/endpoints'
import {
	MdcResultList,
	DiseaseResultList,
	DpcResultList,
	SisetusDpcResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const useListMdc = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<MdcResultList>(
        apiAccess,
				dpcApi('/mdc/list', { t }),
        cancelToken
      )
    },
		[]
	)
)

export const useListDpcDisease = (
	mdcCode?: string | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!mdcCode) return null
      return ApiGetWithToken<DiseaseResultList>(
        apiAccess,
				mdcCode === 'all' ? dpcApi('/disease/list') :
				dpcApi(`/mdc/${mdcCode}/dpc/list`, { t }),
        cancelToken
      )
    },
		[mdcCode]
	)
)

export const useListDpcResultBySisetu = (
	sisetuCode: string | null | undefined
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!sisetuCode) return null
      return ApiGetWithToken<DpcResultList>(
        apiAccess,
				sisetuApiBy(sisetuCode, '/dpc', { t }),
        cancelToken
      )
    },
		[sisetuCode]
	)
)

export const useListMdcResult = (
	mdcCode: string | null | undefined,
	prefectureCode: string[],
	year: number | undefined
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!mdcCode || prefectureCode.length === 0) return null
      return ApiGetWithToken<SisetusDpcResultList>(
        apiAccess,
				dpcApi(`/mdc/${mdcCode}/result`, {
					t, year,
					pref: prefectureCode?.join(',')
				}),
        cancelToken
      )
    },
		[mdcCode, year, prefectureCode]
	)
)

export const useListDpcResult = (
	dpcCode: string | null | undefined,
	prefectureCode: string | undefined,
	iryokenCode: number | undefined,
	year: number | undefined,
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!dpcCode || !year) return null
      return ApiGetWithToken<SisetusDpcResultList>(
        apiAccess,
				dpcApi(`/dpc/${dpcCode}/result`, {
					t, year,
					pref: prefectureCode,
					iryoken: iryokenCode
				}),
        cancelToken
      )
    },
		[dpcCode, year, prefectureCode, iryokenCode]
	)
)
